import { client } from '@mb/api/client';
import { AxiosResponse } from 'axios';

export interface DownloadHistoryItem {
  order_id: number;
  product_id: number;
  product_name: string;
  product_image: string;
  project_id: number;
  attachment_id: number;
  attachment_name: string;
  attachment_url: string;
  brand_name: string;
  category_id: number;
  category_name: string;
  created_at: string;
  project_title: string;
  times_downloaded: number;
  product_sku: number;
  parent_product_sku: number;
  product_url?: string;
}

export interface DownloadHistoryResponse {
  items: DownloadHistoryItem[];
  page: number;
  page_size: number;
  total: number;
}

export const fetchDownloads = (
  page: number = 1,
  brandId?: number,
  projectId?: number,
  categoryId?: number,
  sortDirection?: 'ASC' | 'DESC',
): Promise<AxiosResponse<DownloadHistoryResponse>> => {
  let requestUrl = `/rest/V1/digital_sampling/download_history?page=${page}`;

  if (!!brandId) {
    requestUrl += `&brandId=${brandId}`;
  }

  if (!!projectId) {
    requestUrl += `&projectId=${projectId}`;
  }

  if (!!categoryId) {
    requestUrl += `&categoryId=${categoryId}`;
  }

  if (!!sortDirection) {
    requestUrl += `&sortDirection=${sortDirection}`;
  }

  return client.get(requestUrl);
};

// Fetch product JSON data
const productJsonUrl = '/configurable/product/json';

type ProductJsonResponse = {
  status: string;
  message?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Record<string, any>;
};

type ProductJsonApiResult =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  | { success: true; data: Record<string, any> }
  | { success: false; error: string };

export async function fetchProductJson(
  childId: string,
): Promise<ProductJsonApiResult> {
  try {
    const res = await client.post<ProductJsonResponse>(
      productJsonUrl,
      `productId=${encodeURIComponent(childId)}`,
    );

    if (res.data?.status === 'success') {
      return {
        success: true,
        data: res.data.data,
      };
    }

    return {
      success: false,
      error: res.data?.message ?? 'Unknown error occurred',
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    return {
      success: false,
      error: err?.message ?? 'Network or server error',
    };
  }
}
